import { BackendConfigSiteInterface } from 'common/data/backend/config/site.interface';
import { BackendConfigSiteDefault } from 'common/data/backend/config/site-default';

/**
 * Returns site settings
 */
export function configGetSite(): BackendConfigSiteInterface {
  return window.propertyfinder && window.propertyfinder.site ? window.propertyfinder.site : BackendConfigSiteDefault;
}
